import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* REMOVE-FOR-CLIENT-SSR-START */
export const controllers = [{value: () => import(/* webpackPreload: true */ "./@module/controller.js"), path: "./@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./AutomatedMessages/@module/controller.js"), path: "./AutomatedMessages/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./Members/@module/controller.js"), path: "./Members/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./NotificationsList/@module/controller.js"), path: "./NotificationsList/@module/controller.js"}];
export const models = [];
/* REMOVE-FOR-CLIENT-SSR-END */
export const libs = [];
export const styles = [{value: () => import(/* webpackPreload: true */ "./@styles/AutomatedMessages.styles.js"), path: "./@styles/AutomatedMessages.styles.js"}, {value: () => import(/* webpackPreload: true */ "./@styles/Contacts.styles.js"), path: "./@styles/Contacts.styles.js"}, {value: () => import(/* webpackPreload: true */ "./@styles/ContactsListSearch.styles.js"), path: "./@styles/ContactsListSearch.styles.js"}, {value: () => import(/* webpackPreload: true */ "./@styles/Notifications.styles.js"), path: "./@styles/Notifications.styles.js"}];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
